import client from './index'

export interface LocalizationFile {
  id: string
  original_name: string
  file_path: string
  is_active: boolean
  created_at: string
  updated_at: string
}

export const getLocalizationFiles = () => {
  return client.get<LocalizationFile[]>('/localization-files')
}

export const uploadLocalizationFile = (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  return client.post<LocalizationFile>('/localization-files/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const activateLocalizationFile = (id: string) => {
  return client.patch<LocalizationFile>(`/localization-files/${id}/activate`)
}

export const deleteLocalizationFile = (id: string) => {
  return client.delete<null>(`/localization-files/${id}`)
}
